// components/sections/displays/divider/divider-display.styles.jsx

import styled from 'styled-components';

export const DividerContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem 0;
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background-color: #ccc;
`;